import React from "react";
import { Nav } from "components";
import { Link } from "react-router-dom";
import { View, useIsMobile } from "hooks";
import { Stack } from "@mui/material";
import MusicPlayer from "./musicPlayer/MusicPlayer";

function Header() {
  const { view } = useIsMobile();
  return (
    <Stack>
      <div
        style={{
          backgroundColor: "white",
          display: "flex",
          padding: "5px",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            padding: "5px",
            borderBottom: "solid 2px #7a1414",
          }}
        >
          <Link to="/">
            <img src="/hhlogo.jpg" alt="Harmony Hill Logo" />
          </Link>
        </div>
        {View.Mobile !== view && (
          <Stack width="100%">
            <MusicPlayer />
            {View.Tablet !== view && <Nav />}
          </Stack>
        )}
        {View.Mobile === view && <Nav />}
      </div>
    </Stack>
  );
}

export default Header;
